import { listSetBanners } from "@api/banners";
import { useBannerStore } from "@store/useBannerStore";

/**
 * 배너 정보를 직접 관리하는 커스텀 훅
 */
const useBannerList = () => {
  const setBannerList = useBannerStore((s) => s.setBannerList);

  const getBannerList = async () => {
    try {
      const res = await listSetBanners({ modes: "ListSet" });
      if (res.Code === "0000") {
        const data = res?.Data?.rows ?? [];

        setBannerList(data); // Zustand에 저장

        return data;
      } else {
        setBannerList([]);

        return null;
      }
    } catch (error) {
      console.error("getBannerList error:", error);
      setBannerList([]);
      return null;
    }
  };

  return {
    getBannerList,
  };
};

export default useBannerList;
